/*
 * @Author: zhengxiaowen 
 * @Date: 2018-10-11 19:21:09 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 01:52:59
 */


import demoPage2 from '../demoPage2'



let router = [
    {
        path: '/demoPage2',
        name: 'demoPage2',
        component: demoPage2,
        backPath:'',
        cnName:'demoPage2'
    },
    
]

export default router


// WEBPACK FOOTER //
// ./src/page/devDemo2/config/router.js